module.exports = __webpack_public_path__ + "img/2.942a39c6.png";